export default __webpack_public_path__ + "static/media/image_casa.a0b5431d.png";